<template>
  <c-row>
    <c-col col="5">
      <c-card>
        <c-card-header>
          <strong>Add User</strong>
        </c-card-header>
        <c-card-body>
          <div class="form-group form-row">
            <label for="name" class="col-form-label col-sm-4">name</label>
            <div class="col-md-8">
              <input
                type="text"
                placeholder="name"
                class="form-control"
                v-bind:class="{ 'has-error': hasError.name }"
                v-model="user.name"
              />
            </div>
          </div>
          <div class="form-group form-row">
            <label for="name" class="col-form-label col-sm-4">Email</label>
            <div class="col-md-8">
              <input
                type="email"
                placeholder="email"
                class="form-control"
                v-bind:class="{ 'has-error': hasError.email }"
                v-model="user.email"
                required
                :readonly="user.id"
              />
            </div>
          </div>
          <div class="form-group form-row">
            <label for="name" class="col-form-label col-sm-4">Phone</label>
            <div class="col-md-8">
              <input
                type="text"
                placeholder="phone"
                class="form-control"
                v-bind:class="{ 'has-error': hasError.phone }"
                v-model="user.phone"
              />
            </div>
          </div>
          <div v-show="resetPass || !user.id">
            <div class="form-group form-row">
              <label for="name" class="col-form-label col-sm-4">Password</label>
              <div class="col-md-8">
                <input
                  type="password"
                  placeholder="password"
                  class="form-control"
                  v-bind:class="{ 'has-error': hasError.password }"
                  v-model="user.password"
                />
              </div>
            </div>
            <div class="form-group form-row">
              <label for="name" class="col-form-label col-sm-4"
                >Confirm Password</label
              >
              <div class="col-md-8">
                <input
                  type="password"
                  placeholder="confirm password"
                  class="form-control"
                  v-bind:class="{ 'has-error': hasError.password_confirmation }"
                  v-model="user.password_confirmation"
                />
              </div>
            </div>
          </div>
          <div class="form-group form-row" v-show="!resetPass && user.id">
            <label for="name" class="col-form-label col-sm-4"></label>
            <div class="col-md-8">
              <button class="btn btn-danger" @click="showReset">
                Reset Password
              </button>
            </div>
          </div>
        </c-card-body>
        <c-card-footer>
          <sur-button
            :object="user"
            @onSave="save"
            @onUpdate="update"
            @onReset="reset"
          ></sur-button>
        </c-card-footer>
      </c-card>
    </c-col>
    <c-col col="7" v-if="user">
      <menu-table :menu="menu" :userId="user.id" />
    </c-col>
  </c-row>
</template>
<script>
import MenuTable from '../../components/MenuTable.vue';
import SURButton from "../../components/SURButton";
import { HTTPAUTH } from "../../lib/httplib";
export default {
  name: "UserAdd",
  components: {
    "sur-button": SURButton,
    MenuTable
  },
  data () {
    return {
      user: {},
      hasError: {},
      resetPass: false,
      menu: []
    };
  },
  created () {
    const query = this.$route.query;
    if (query.id) {
      this.get(query.id);
      this.getMenu(query.id)
    }
  },
  methods: {
    save () {
      HTTPAUTH.post("/api/v1/user", this.user)
        .then((res) => {
          this.$toasted.success("Berhasil menyimpan data").goAway(1000);
          this.$router.push({ query: { id: res.data.data.id } })
          this.get(res.data.data.id)
          this.getMenu(res.data.data.id)
          // this.reset();
        })
        .catch(eres => {
          this.$toasted.error(eres.response.data.message).goAway(3000);
          this.hasError = eres.response.data.errors;
          if (this.hasError.password && this.hasError.password[0].includes("confirmation")) {
            this.hasError.password_confirmation = [this.hasError.password[0]];
          }
        });
    },
    update () {
      this.user.resetPass = this.resetPass;
      HTTPAUTH.put(`/admin/v1/user/${this.user.id}/edit`, this.user)
        .then((res) => {
          this.$toasted.success("Berhasil menyimpan data").goAway(1000);
          this.get(res.data.data.id)
          this.getMenu(res.data.data.id)
        })
        .catch(eres => {
          this.$toasted.error(eres.response.data.message).goAway(3000);
          this.hasError = eres.response.data.errors;
          if (this.hasError.password && this.hasError.password[0].includes("confirmation")) {
            this.hasError.password_confirmation = [this.hasError.password[0]];
          }
        });
    },
    reset () {
      this.user = {};
      this.resetPass = false;
      this.$router.push({ query: {} });
    },
    get (id) {
      HTTPAUTH.get("/api/v1/user/" + id).then(res => {
        this.user = res.data.data;
      });
    },
    showReset () {
      this.resetPass = true;
    },
    getMenu (id) {
      HTTPAUTH.get(`/api/menu/access/${id}`).then(res => {
        this.menu = res.data.data
      }).catch(() => {
        this.getDefaultMenu();
      })
    },
    getDefaultMenu () {
      HTTPAUTH.get(`/api/menu`).then(res => {
        this.menu = res.data.data
      });
    }
  }
};
</script>